import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {
  AuthUserRefence,
  IpifyResponse,
  RequestChangePassword,
  RequestChangePasswordValidation,
  RequestValidationPassword,
  RequestValidationToken,
  ResponseToken,
  ResponseTokenValidation,
} from '../interfaces/auth-user-data.interface';
import {jwtDecode} from 'jwt-decode';
import {AuthRepository} from '../../store/auth.repository';
import {User} from 'src/app/features/user/shared/user.model';
import {AUTH_SERVICE_AZURE} from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly authRepository: AuthRepository
  ) {}

  static decodeToken(token: string): {exp: number} | null {
    try {
      return jwtDecode(token);
    } catch (e) {
      return null;
    }
  }

  public userValidation(authUserRefence: AuthUserRefence) {
    return this.httpClient.post<ResponseToken>(
      `${AUTH_SERVICE_AZURE}ValidarUsuarioDobleAuth`,
      authUserRefence
    );
  }

  public tokenOtpValidation(requestValidationToken: RequestValidationToken) {
    return this.httpClient
      .post<ResponseTokenValidation>(
        `${AUTH_SERVICE_AZURE}ValidarCodigoOtp`,
        requestValidationToken
      )
      .pipe(
        map((responseTokenValidation: ResponseTokenValidation) => {
          if (responseTokenValidation.indResultado === 1) {
            const _token = this.authRepository.getResponseToken().token;
            const user: User = {token: _token, otpToken: true};
            this.authRepository.setUser(user);
          }
          return responseTokenValidation;
        })
      );
  }
  public validateRecoverPassword(
    requestValidationPassword: RequestValidationPassword
  ) {
    return this.httpClient.post<ResponseToken>(
      `${AUTH_SERVICE_AZURE}ValidarRecuperarClave`,
      requestValidationPassword
    );
  }

  public setDefaultPassword(
    requestValidationPassword: RequestValidationPassword
  ) {
    return this.httpClient.post<ResponseTokenValidation>(
      `${AUTH_SERVICE_AZURE}RecuperarClave`,
      requestValidationPassword
    );
  }

  public validateChangePassword(
    requestChangePassword: RequestChangePasswordValidation
  ) {
    return this.httpClient.post<ResponseToken>(
      `${AUTH_SERVICE_AZURE}ValidarCambioClave`,
      requestChangePassword
    );
  }

  public changePassword(requestChangePassword: RequestChangePassword) {
    return this.httpClient.post<ResponseToken>(
      `${AUTH_SERVICE_AZURE}CambiarClave`,
      requestChangePassword
    );
  }

  public getIpAddress(): Observable<string> {
    return this.httpClient
      .get<IpifyResponse>('/ipify?format=json', {responseType: 'json'})
      .pipe(map(response => response.ip));
  }
}
